module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306235.4d273e1a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_306235.pdf
// module id = 822
// module chunks = 0